import { render, staticRenderFns } from "./storeMenu.vue?vue&type=template&id=72f64f9e&"
import script from "./storeMenu.vue?vue&type=script&lang=js&"
export * from "./storeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports